<template>
  <div class="exchange-i">
    <Header title="指导内容" type="0" route="/design"></Header>
    <div class="list-head" >
      <div>
        <p>学生学号：{{designReCodeList.studentnumber?designReCodeList.studentnumber:''}}</p>
        <p>学生姓名：{{designReCodeList.studentname?designReCodeList.studentname:''}}</p>
        <p>设计（论文）题目：{{designReCodeList.topicname?designReCodeList.topicname:''}}</p>
      </div>
             
      </div>
      <div class="exchange">
      <p>学生提问</p>
      <div>
        <span v-html='msg_req'>
        </span>
      </div>  
    </div>
    <div class="exchange">
      <p>导师回复</p>
      <div>
        <span v-html='msg_resp'>
        </span>
      </div>  
    </div>
    <div class="bottom-btn" v-if="designReCodeList.shzt=='3'">
      <button @click="toSubmitGuide">审核</button>
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        title="审核状态"
        show-toolbar
        :columns="valueList.item"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(index);
          }
        "
      />
    </van-popup>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      designReCodeList: {},
      msg_req:'',
      msg_resp:'',
      msgContext:"",
      valueList: {
        label: "通过",
        value: "1",
        item: ""
      },
      columns:[{'text':'通过','value':'1'},{'text':'不通过','value':'0'}],
      show:false
    };
  },
  methods: {
    onConfirm(index) {
      this.valueList.label = this.columns[index].text;
      this.valueList.value = this.columns[index].value;
      this.show = false;
      this.saveIswfmes();
    },
    async loadZdmsgDeal(){
      const params = {
        ywstid: this.$route.query.ywstid,
      };
      const res = await Api.loadZdmsgDeal(params);
      if(res.code=='1'){
        this.designReCodeList = res.data;
        this.msg_req = res.data.requstcontext;
        this.msg_resp =  res.data.responsecontext
      }
    },
     toSubmitGuide(){
      this.show = true;
      this.valueList.item = this.columns;
      const params = {
        ywstid: this.$route.query.ywstid,
        guidContext:this.msg,
      };
    },
    async saveIswfmes(){
      const params = {
        ywstid: this.$route.query.ywstid,
        iswfmes:this.valueList.value,
      };
      const res = await Api.saveIswfmes(params);
      if(res.code=='1'){
        this.$toast.success("审核成功!");
        setTimeout(() => {
          this.$router.replace("/design");
        }, 1500);
      }
    }     
  },
  created() {
    this.loadZdmsgDeal();
  }
};
</script>
<style lang="less" scoped>
.exchange-i {
  .list-head {
      height: 100px;
      background-image: url("../../../../static/image/head.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: flex;
      padding-left: 6%;
      padding-top: 2%;
      box-sizing: border-box;
      margin-bottom: 1%;
      width: 90%;
      margin-left: 5%;
      margin-right: 5%;
      div {
        width: 90%;
        height: 100%;
        p {
          font-size: 14px;
          color: #fff;
          font-weight: lighter;
          margin-bottom: 2%;
        }
        
      }
    }
  .exchange {
    padding-left: 5%;
    padding-top: 3%;
    padding-right: 5%;
    
    height: 35vh;
    p {
        height: 22px;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #212f6e;
        letter-spacing: 0;
        font-weight: bolder;
        margin-bottom: 2%;
      }
     div{
      box-sizing: border-box;
      background-color: #f8f8f8;
      border-radius: 8px;
      height: 30vh;
      word-wrap: break-word;
      overflow:auto;
      padding: 5px 5px;
     }

  }
  .bottom-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    padding-bottom: 10px;
    padding: 0 5%;
    background: #fff;
    box-sizing: border-box;

    button {
      width: 100%;
      height: 44px;
      background: #7469f8;
      border-radius: 3px;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/Design/guideDeal_unload.vue